export default "__VITE_ASSET__BybI5Qpf__"